import { Head, router, useForm } from "@inertiajs/react"

import PartnerUserForm from "@/components/partners/partner-user-form"
import RecordForm from "@/components/record-form"
import RecordPageHeader from "@/components/ui/record-page-header"
import AdminLayout from "@/layouts/admin-layout"
import {
  adminPartnerUsersPath,
  adminPartnersPath,
  newAdminPartnerUserPath,
} from "@/routes"
import type { BreadcrumbItem } from "@/types"

interface Partner {
  uid: string
  name: string
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Partners", href: adminPartnersPath() },
  { title: "New Partner User", href: newAdminPartnerUserPath() },
]

export default function NewPartnerUser({ partners }: { partners: Partner[] }) {
  const { data, setData, post, processing, errors } = useForm({
    partner_user: {
      name: "",
      email: "",
      partner_uid: "",
      avatar: null as File | null,
      send_welcome_email: "1",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(adminPartnerUsersPath(), { forceFormData: true })
  }

  function handleCancel() {
    router.visit(adminPartnersPath())
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title="New Partner User" />
      <div className="flex h-full w-full flex-col gap-6 p-4">
        <div className="mx-auto w-full max-w-2xl">
          <RecordPageHeader title="New Partner User" />
        </div>
        <RecordForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
        >
          <PartnerUserForm
            data={data}
            setData={setData}
            errors={errors}
            partners={partners}
          />
        </RecordForm>
      </div>
    </AdminLayout>
  )
}
